// Workaround for Mantine 5

import { TextInput } from '@mantine/core'

const Component = (props: any) => <TextInput {...props} />

export default function MaskedTextInput({ MaskedComponent, ...inputProps }: any) {
  return <Component component={MaskedComponent} {...inputProps} />
}
